import { render, staticRenderFns } from "./SetupPage.vue?vue&type=template&id=29522750&scoped=true"
import script from "./SetupPage.vue?vue&type=script&lang=js"
export * from "./SetupPage.vue?vue&type=script&lang=js"
import style0 from "./SetupPage.vue?vue&type=style&index=0&id=29522750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29522750",
  null
  
)

export default component.exports